import React from "react"
import { LoadingIconSeeker } from "@ui-seeker/core"
import { AppDialogTabs } from "@components"
import { INFO_MODAL_TABS } from "Pages/ReportsAlerts/Reports/@constants"
import { isInfoModalHistoryLoading, selectedInfoModalTab } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportInfoModalTabs({ timestampLastExecution }) {

	return <AppDialogTabs
		value={selectedInfoModalTab.value}
		onChange={(_, e) => selectedInfoModalTab.value = e}
		tabs={[{
			value: INFO_MODAL_TABS.DETAILS,
			label: 'Details',
			icon: 'memo-circle-info',
		}, {
			value: INFO_MODAL_TABS.HISTORY,
			label: 'History',
			icon: 'clock-rotate-left',
			disabled: !timestampLastExecution,
			end: isInfoModalHistoryLoading.value && <LoadingIconSeeker/>,
		}]}
	/>
}
